import { render, staticRenderFns } from "./join-live.vue?vue&type=template&id=95f6b5cc&scoped=true"
import script from "./join-live.vue?vue&type=script&lang=js"
export * from "./join-live.vue?vue&type=script&lang=js"
import style0 from "./join-live.vue?vue&type=style&index=0&id=95f6b5cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f6b5cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95f6b5cc')) {
      api.createRecord('95f6b5cc', component.options)
    } else {
      api.reload('95f6b5cc', component.options)
    }
    module.hot.accept("./join-live.vue?vue&type=template&id=95f6b5cc&scoped=true", function () {
      api.rerender('95f6b5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/components/join-live.vue"
export default component.exports